<!-- features/countries/page/countries-list/countries-list.html -->
<ui-organism-title-logos/>
<ui-atom-spacer />
<!-- <ui-atom-text type="medium" [text]="'countries.list.subtitle' | translate"> </ui-atom-text> -->
<ui-atom-spacer size="spacer-xxl" />

<!-- Tabs con Countries y Users -->
<div class="countries-tabs">
  <mat-tab-group
    [(selectedIndex)]="selectedTab"
    (selectedIndexChange)="onTabChange($event)"
    class="countries-tabs__group"
  >
    <!-- Tab Countries -->
    <mat-tab>
      <ng-template matTabLabel>
        {{ 'countriesTabs.countries' | translate }}
      </ng-template>
      <div class="countries-tabs__content">
        <div class="forms-header">
          <ui-atom-text type="medium" [text]="'countries.list.actions.goTo' | translate">
          </ui-atom-text>
        </div>
        <ui-atom-global-search (search)="onGlobalSearch($event)" />
        <section class="countries-list-table">
          <ui-molecule-mat-table
            [data]="tableData"
            [columns]="tableColumns"
            [paginator]="true"
            paginationMode="server"
            [totalItems]="totalItems"
            [pageIndex]="pageIndex"
            [pageSize]="pageSize"
            [isLoading]="isLoading"
            [actions]="tableActions"
            [showClearFiltersButton]="false"
            [showGlobalSearch]="false"
            [exportFileName]="'countries'"
            [useExportColumnPicker]="true"
            (actionClick)="onTableAction($event)"
            (rowClick)="onTableRowClick($event)"
            (pageChange)="onTablePageChange($event)"
            (sortChange)="onTableSortChange($event)"
            (filterChange)="onTableFilterChange($event)"
            (exportAllDataWithColumns)="onExportAllCountries($event)"
          >
            <ui-atom-button
              type="button"
              rules="main"
              styling="filled"
              (click)="goToCreate()"
              [text]="'countries.list.actions.create' | translate"
            >
            </ui-atom-button>
          </ui-molecule-mat-table>
        </section>
      </div>
    </mat-tab>

    <!-- Tab Forms -->
    <mat-tab>
      <ng-template matTabLabel>
        {{ 'countriesTabs.forms' | translate }}
      </ng-template>
      <div class="countries-tabs__content">
        <div class="forms-header">
          <ui-atom-text type="medium" [text]="'countriesForms.subtitle' | translate">
          </ui-atom-text>
        </div>
        <ui-atom-global-search (search)="onFormsGlobalSearch($event)" />
        <section class="forms-list-table">
          <ui-molecule-mat-table
            [data]="formsData"
            [columns]="formsColumns"
            [paginator]="true"
            paginationMode="server"
            [totalItems]="formsTotalItems"
            [pageIndex]="formsPageIndex"
            [pageSize]="formsPageSize"
            [isLoading]="isLoadingForms"
            [actions]="formsActions"
            [showClearFiltersButton]="false"
            [showGlobalSearch]="false"
            [exportFileName]="'forms'"
            [useExportColumnPicker]="true"
            (actionClick)="onFormAction($event)"
            (rowClick)="onFormRowClick($event)"
            (pageChange)="onFormPageChange($event)"
            (sortChange)="onFormSortChange($event)"
            (filterChange)="onFormFilterChange($event)"
            (exportAllDataWithColumns)="onExportAllForms($event)"
          >
            <ui-atom-button
              type="button"
              rules="main"
              styling="filled"
              (click)="openCreateFormDialog()"
              [text]="'countriesForms.create' | translate"
              icon="add"
            >
            </ui-atom-button>
          </ui-molecule-mat-table>
        </section>
      </div>
    </mat-tab>
    <!-- Tab Users -->
    <mat-tab>
      <ng-template matTabLabel>
        {{ 'countriesTabs.users' | translate }}
      </ng-template>
      <div class="countries-tabs__content">
        <div class="forms-header">
          <ui-atom-text type="medium" [text]="'countriesUsers.subtitle' | translate">
          </ui-atom-text>
        </div>
        <ui-atom-global-search (search)="onUserGlobalSearch($event)" />
        <section id="users-table" class="users-list-table">
          <ui-molecule-mat-table
            [data]="usersData"
            [columns]="userColumns"
            [paginator]="true"
            paginationMode="server"
            [totalItems]="userTotalItems"
            [pageIndex]="userPageIndex"
            [pageSize]="userPageSize"
            [isLoading]="isLoadingUsers"
            [actions]="userActions"
            [showClearFiltersButton]="false"
            [showGlobalSearch]="false"
            [exportFileName]="'users'"
            (actionClick)="onUserAction($event)"
            (pageChange)="onUserPageChange($event)"
            (sortChange)="onUserSortChange($event)"
            (exportAllData)="onExportAllUsers()"
          >
            <ui-atom-button
              type="button"
              rules="main"
              styling="filled"
              (click)="openCreateUserDialog()"
              [text]="'countriesUsers.create' | translate"
            >
            </ui-atom-button>
          </ui-molecule-mat-table>
        </section>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
